import * as Yup from 'yup'

/*
  Cadastro da conta bancária que vai receber os saques.

  O banco vem do nosso cadastro (`GET /banks`) e viaja como `bankId`: é a API que resolve
  o código do banco a partir dele, então o titular nunca digita esse número. Agência e
  conta são conferidas aqui só quanto ao formato — quem sabe se a conta existe é o banco, e
  a recusa dele chega na resposta do cadastro.

  Não há campo de titular: o Asaas preenche nome e documento a partir da própria subconta,
  e é isso que impede o saque de virar transferência para a conta de outra pessoa.
*/
const bankingWithdrawalAccountValidator = Yup.object ().shape ({
  bank: Yup.object ()
    .nullable ()
    .required ('Selecione o seu banco'),

  bankAccountType: Yup.object ()
    .nullable ()
    .required ('Selecione o tipo da conta'),

  agency: Yup.string ()
    .required ('Insira a agência')
    .matches (/^\d{1,6}$/, 'A agência tem só números, sem o dígito'),

  account: Yup.string ()
    .required ('Insira o número da conta')
    .matches (/^\d{1,15}$/, 'O número da conta tem só números, sem o dígito'),

  // Opcional porque nem todo banco usa dígito verificador na conta.
  accountDigit: Yup.string ()
    .matches (/^[0-9xX]?$/, 'O dígito é um número ou X')
})

export default bankingWithdrawalAccountValidator
